/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ReferenceFilter } from "./ReferenceFilter";
export const ReferenceListPropertyConfig = core.serialization.object({
    ref: core.serialization.string(),
    key: core.serialization.string(),
    filter: ReferenceFilter.optional(),
});
